import React from 'react'
import PropTypes from 'prop-types'
import { ExitInterviewStatisticsItems } from '../../organism'
import { MODULES } from '../../../config/constants'
import eventTracker from '../../../utils/eventTracker';

const Statistics = ({ classes }) => {
  eventTracker.track('EIStatisticsView', {
    url: document.location.href,
  })
  return (
    <div className={classes.root}>
      <ExitInterviewStatisticsItems module={MODULES.ID_EXIT_INTERVIEW} />
    </div>
  )
}

Statistics.propTypes = {
  classes: PropTypes.object.isRequired
}

export default Statistics
